import React, { Component } from 'react';
import UI from '../ui';
import Utils from '../utils';

const { WrappedCheckbox, WrappedCheckboxWithLabel, WrappedRadioButton } = UI;
const { Logger } = Utils;

class AdditionalOptions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showAllOptions: false,
			showCoverageOptions: false,
		};
	}

	/**
	 * Notify the parent about the filter change.
	 * @param {object} data The filter changes to be saved.
	 */
	notifyParent = data => {
		const { onFiltersChange, rateAdvisorData } = this.props;
		const { otherOptions } = rateAdvisorData;

		if (onFiltersChange) {
			onFiltersChange('otherOptions', {
				...otherOptions,
				...data,
			});
		}
	};

	sendLog = (name, checked) => {
		const nameLookup = {
			includedCoverage: 'included_coverage',
			freePickup: 'free_pickup',
			trackable: 'tracking',
			guaranteedDeliveryDate: 'guaranteed_date',
			guaranteedDeliveryTime: 'guaranteed_time',
			saturdayDelivery: 'saturday_delivery',
			sundayDelivery: 'sunday_delivery',
		};

		Logger.logToServer({
			category: 'ra_filter_change',
			ui_element: nameLookup[name],
			value: checked ? 'on' : 'off',
		});
	};

	onChangeRadioButtons = ({ value }) => {
		this.notifyParent({
			includedCoverageSelection: value,
		});
	};

	onClickCheckbox = e => {
		const { name, checked } = e.target;

		this.notifyParent({
			[name]: checked,
		});

		this.sendLog(name, checked);
	};

	handleShowCoverageOptionsChange = () => {
		this.setState(({ showCoverageOptions }) => ({
			showCoverageOptions: !showCoverageOptions,
		}));
	};

	handleShowMoreOptionsChange = () => {
		this.setState(({ showAllOptions }) => ({
			showAllOptions: !showAllOptions,
		}));
	};

	render() {
		const { rateAdvisorData } = this.props;
		const { showCoverageOptions, showAllOptions } = this.state;
		const { otherOptions } = rateAdvisorData;
		const showLabelAfter = true;

		return (
			<div className="common-rate-advisor-additional-options">
				<div className="options-title">Additional Options</div>
				<div className="options-item">
					<WrappedCheckbox
						dataqa="options-checkbox-included-coverage"
						name="includedCoverage"
						onChange={this.onClickCheckbox}
						checked={otherOptions.includedCoverage}
					>
						<span
							role="button"
							tabIndex={0}
							className="included-coverage-label"
							onClick={this.handleShowCoverageOptionsChange}
						>
							Included Coverage:
						</span>
					</WrappedCheckbox>
					<span>
						<i
							role="button"
							tabIndex={0}
							aria-label="show_coverage_options"
							className={
								showCoverageOptions ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
							}
							onClick={this.handleShowCoverageOptionsChange}
							onKeyDown={this.handleShowCoverageOptionsChange}
						/>
					</span>
				</div>
				{showCoverageOptions && (
					<div className="options-radio-buttons">
						<WrappedRadioButton
							name="optionsRadioIncludedCoverageAny"
							checked={otherOptions.includedCoverageSelection === 'any'}
							value="any"
							className="options-radio"
							dataqa="optionsradioincludedcoverageany"
							onChange={this.onChangeRadioButtons}
							disabled={!otherOptions.includedCoverage}
						>
							Any
						</WrappedRadioButton>
						<WrappedRadioButton
							name="optionsRadioIncludedCoverage100"
							checked={otherOptions.includedCoverageSelection === '100'}
							value="100"
							className="options-radio"
							dataqa="optionsradioincludedcoverage100"
							onChange={this.onChangeRadioButtons}
							disabled={!otherOptions.includedCoverage}
						>
							$100
						</WrappedRadioButton>
						<WrappedRadioButton
							name="optionsRadioIncludedCoverage200"
							checked={otherOptions.includedCoverageSelection === '200'}
							value="200"
							className="options-radio"
							dataqa="optionsradioincludedcoverage200"
							onChange={this.onChangeRadioButtons}
							disabled={!otherOptions.includedCoverage}
						>
							$200
						</WrappedRadioButton>
					</div>
				)}
				<div className="options-item">
					<WrappedCheckboxWithLabel
						label="Trackable (only)"
						showLabelAfter={showLabelAfter}
						uiElementConfig={{
							dataqa: 'options-checkbox-trackable',
							name: 'trackable',
							onChange: this.onClickCheckbox,
							checked: otherOptions.trackable,
						}}
					/>
				</div>
				<div className="options-item">
					<WrappedCheckboxWithLabel
						label="Free Pickup (only)"
						showLabelAfter={showLabelAfter}
						uiElementConfig={{
							dataqa: 'options-checkbox-pickup',
							name: 'freePickup',
							onChange: this.onClickCheckbox,
							checked: otherOptions.freePickup,
						}}
					/>
				</div>
				<div className="options-item">
					<WrappedCheckboxWithLabel
						label="Guar. Deliv. Date"
						showLabelAfter={showLabelAfter}
						uiElementConfig={{
							dataqa: 'options-checkbox-guaranteed-delivery-date',
							name: 'guaranteedDeliveryDate',
							onChange: this.onClickCheckbox,
							checked: otherOptions.guaranteedDeliveryDate,
						}}
					/>
				</div>
				{showAllOptions && (
					<div className="options-item">
						<WrappedCheckboxWithLabel
							label="Guar. Deliv. Time"
							showLabelAfter={showLabelAfter}
							uiElementConfig={{
								dataqa: 'options-checkbox-guaranteed-delivery-time',
								name: 'guaranteedDeliveryTime',
								onChange: this.onClickCheckbox,
								checked: otherOptions.guaranteedDeliveryTime,
							}}
						/>
					</div>
				)}
				{showAllOptions && (
					<div className="options-item">
						<WrappedCheckboxWithLabel
							label="Saturday Delivery"
							showLabelAfter={showLabelAfter}
							uiElementConfig={{
								dataqa: 'options-checkbox-saturday-delivery',
								name: 'saturdayDelivery',
								onChange: this.onClickCheckbox,
								checked: otherOptions.saturdayDelivery,
							}}
						/>
					</div>
				)}
				{showAllOptions && (
					<div className="options-item">
						<WrappedCheckboxWithLabel
							label="Sunday/Holiday Del."
							showLabelAfter={showLabelAfter}
							uiElementConfig={{
								dataqa: 'options-checkbox-sunday-delivery',
								name: 'sundayDelivery',
								onChange: this.onClickCheckbox,
								checked: otherOptions.sundayDelivery,
							}}
						/>
					</div>
				)}
				<div
					role="button"
					tabIndex={0}
					className="options-button"
					onClick={this.handleShowMoreOptionsChange}
					{...{ dataqa: 'rate-advisor-additional-options-show-more-button' }}
				>
					{showAllOptions ? 'Show fewer options' : 'Show more options'}
					<i
						role="button"
						aria-label="show-options"
						className={showAllOptions ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
					/>
				</div>
			</div>
		);
	}
}

export default AdditionalOptions;
